import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import { CookieSettingsButton } from '@app/components/consent/CookieSettingsButton';
import { AnimatedChefHat } from '@app/components/motion/AnimatedChefHat';
import { css } from 'styled-system/css';
export function Footer() {
  const $ = _c(13);
  let t0;
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = css({
      py: "page.y.md",
      mt: "page.y.md",
      textAlign: "center",
      fontFamily: "body",
      fontSize: "sm",
      color: "text.muted",
      background: "surface.card",
      boxShadow: "shadow.medium"
    });
    t1 = css({
      maxWidth: "600px",
      margin: "0 auto",
      padding: "0 4"
    });
    t2 = <div className={css({
      fontSize: "2xl",
      marginBottom: "3",
      color: "palette.orange"
    })}><AnimatedChefHat /></div>;
    t3 = <div className={css({
      fontWeight: "600",
      color: "text",
      marginBottom: "2"
    })}>KochTakt</div>;
    t4 = css({
      marginBottom: "3"
    });
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className={t4}>© {new Date().getFullYear()} KochTakt · Produkte mit Gefühl entdecken</div>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = css({
      display: "flex",
      flexWrap: "wrap",
      gap: "4",
      justifyContent: "center",
      marginBottom: "3",
      fontSize: "sm"
    });
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Link href="/recipes" className={css({
      _hover: {
        color: "palette.orange"
      },
      transition: "color 0.15s"
    })}>Rezepte</Link>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Link href="/collections" className={css({
      _hover: {
        color: "palette.orange"
      },
      transition: "color 0.15s"
    })}>Sammlungen</Link>;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t10;
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <nav aria-label="Footer-Navigation" className={t6}>{t7}{t8}<Link href="/changelog" className={css({
        _hover: {
          color: "palette.orange"
        },
        transition: "color 0.15s"
      })}>Changelog</Link></nav>;
    t10 = css({
      display: "flex",
      gap: "4",
      justifyContent: "center",
      fontSize: "xs",
      color: "text.muted"
    });
    $[9] = t10;
    $[10] = t9;
  } else {
    t10 = $[9];
    t9 = $[10];
  }
  let t11;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <Link href="/impressum" className={css({
      _hover: {
        color: "palette.orange"
      },
      transition: "color 0.15s"
    })}>Impressum</Link>;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  let t12;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <footer className={t0}><div className={t1}>{t2}{t3}{t5}{t9}<div className={t10}>{t11}<Link href="/datenschutz" className={css({
            _hover: {
              color: "palette.orange"
            },
            transition: "color 0.15s"
          })}>Datenschutz</Link><CookieSettingsButton /></div></div></footer>;
    $[12] = t12;
  } else {
    t12 = $[12];
  }
  return t12;
}